import { IconCopy, IconCreditCardPay, IconLink, IconX } from "@tabler/icons-react";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "sonner";
import { postApi } from "../../../api/call.api";
import { urlApi } from "../../../api/url.api";
import { loadingHide, loadingShow } from "../../../loadingUi/loading.controller";

const GeneratePaymentLinkModal = () => {
    const [show, setShow] = useState(false);
    const [paymentLink, setPaymentLink] = useState("");
    const [transactionId, setTransactionId] = useState("");
    const [amount, setAmount] = useState("");

    const handleClose = () => {
        setPaymentLink("");
        setAmount("");
        setTransactionId("");
        setShow(false);
    };
    const handleShow = () => setShow(true);

    const generate = async () => {
        loadingShow();
        let postData = {
            amount
        }
        let resp = await postApi(postData, urlApi.generatePaymentLink);
        loadingHide()
        if (resp?.responseCode === 200) {
            setPaymentLink(resp?.data?.paymentLink);
            setTransactionId(resp?.data?.transactionId);
            toast.success("Payment link generated!");
        } else {
            setPaymentLink("")
            toast.error(resp?.message);
        }
    };

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
        toast.success("Copied to clipboard!");
    };

    return (
        <>
            <button
                onClick={handleShow}
                className="p-2 rounded-md hover:bg-gray-100 transition"
                title="Generate Payment Link"
            >
                <IconCreditCardPay size={20} className="text-gray-700" />
            </button>

            <Modal show={show} onHide={handleClose} backdrop="static" size="lg" centered>
                <Modal.Body className="rounded-xl p-6 bg-white shadow-lg">
                    {/* Header */}
                    <div className="flex justify-between items-center">
                        <h2 className="text-lg font-semibold text-gray-800">
                            Generate Payment Link
                        </h2>
                        <IconX
                            className="cursor-pointer text-gray-500 hover:text-red-500 transition"
                            onClick={handleClose}
                        />
                    </div>

                    <hr className="my-4 border-gray-200" />

                    <div className="flex flex-col gap-6">
                        {/* Amount Input */}
                        <div>
                            <label
                                htmlFor="amount"
                                className="block text-sm font-semibold text-gray-700 mb-2"
                            >
                                Enter Amount
                            </label>
                            <div className="relative">
                                <span className="absolute left-3 top-2 text-gray-500 font-medium">
                                    ₹
                                </span>
                                <input
                                    type="number"
                                    id="amount"
                                    value={amount}
                                    onChange={(e) => setAmount(e.target.value)}
                                    placeholder="0.00"
                                    min="1"
                                    className="w-full pl-7 pr-3 py-2 border rounded-md text-gray-700 text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary"
                                />
                            </div>
                        </div>

                        {/* Generate Payment Link */}
                        <div>
                            <button
                                onClick={generate}
                                disabled={!amount || amount <= 0}
                                className={`w-full py-2 rounded-md text-white font-semibold transition ${amount && amount > 0
                                    ? "bg-primary hover:bg-orange-600"
                                    : "bg-gray-300 cursor-not-allowed"
                                    }`}
                            >
                                Generate Payment Link
                            </button>
                        </div>

                        {/* Payment Link Display */}
                        {paymentLink && (
                            <div className="p-3 border rounded-md bg-gray-50 shadow-sm">
                                <p className="text-sm font-semibold text-gray-700 mb-2">Payment Link</p>
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-2 truncate">
                                        <IconLink size={18} className="text-primary flex-shrink-0" />
                                        <a
                                            href={paymentLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-sm text-blue-600 underline truncate"
                                        >
                                            {paymentLink}
                                        </a>
                                    </div>
                                    <button
                                        onClick={() => copyToClipboard(paymentLink)}
                                        className="p-2 rounded-md border bg-white hover:bg-gray-100 transition"
                                        title="Copy link"
                                    >
                                        <IconCopy size={16} />
                                    </button>
                                </div>
                            </div>
                        )}

                        {/* Transaction ID Display */}
                        {transactionId && (
                            <div className="p-3 border rounded-md bg-gray-50 shadow-sm">
                                <p className="text-sm font-semibold text-gray-700 mb-2">Transaction ID</p>
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-2 truncate">
                                        <IconCreditCardPay size={18} className="text-primary flex-shrink-0" />
                                        <a
                                            href={transactionId}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-sm text-blue-600 underline truncate"
                                        >
                                            {transactionId}
                                        </a>
                                    </div>
                                    <button
                                        onClick={() => copyToClipboard(transactionId)}
                                        className="p-2 rounded-md border bg-white hover:bg-gray-100 transition"
                                        title="Copy link"
                                    >
                                        <IconCopy size={16} />
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>

                    <hr className="my-4 border-gray-200" />

                    {/* Footer */}
                    <div className="flex justify-end">
                        <button
                            className="px-5 py-2 border rounded-md text-gray-600 hover:bg-gray-100 transition"
                            onClick={handleClose}
                        >
                            Close
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default GeneratePaymentLinkModal;
